import React from 'react'
import CustomSelectR from "../Select/CustomSelectR";
import { connect } from "react-redux";
import {
  selectFilter,
  updateResults,
  setFilterMode,
  setActiveMode,
  resetOnFilter,
  FilterModes, 
  deletePath,
  requestResults
} from "../../store/actions";
import {
  selectFiltersOptions,
  selectResultsCount,
  selectResultsResult,
  selectResultsIsFetching,
  selectParametersMode,
  selectParametersActiveMode,
  selectParametersFilters,
} from "../../store/selectors"


class FinderModeComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      error: false,
    };
    this.selectRefs = {};
    this.selectRefs.group = React.createRef();
    this.selectRefs.category = React.createRef();
    this.selectRefs.lineup = React.createRef();
    this.selectRefs.series = React.createRef();
  }

  resetAll = () => {
    this.selectRefs.group.current.resetValue();
    this.selectRefs.category.current.resetValue();
    this.selectRefs.lineup.current.resetValue();
    this.selectRefs.series.current.resetValue();
  };

  resetError = () => {
    if (this.state.error) {
      this.setState(state => ({ error: false }));
    }
  }



  selectFilter = (key, value) => {
    this.props.requestResults();
    this.props.deletePath(key);

    this.props.selectFilter(key, value);
    if (this.state.error) {
      this.setState(state => ({ error: false }));
    }
    this.props.resetOnFilter();
    // No results. Results are updated when user clicks submit.
    const withResults = false;
    this.props.updateResults(withResults);
  };

  selectFilterAuto = (key, value) => {
    console.debug("FinderMode autoselect", key, value);
    this.props.deletePath(key);
    this.props.selectFilter(key, value);

  };

  getResults = () => {
    this.props.setFilterMode(FilterModes.FILTER_MODE, false);
    const groupSelection = Object.prototype.hasOwnProperty.call(this.props.selections, 'group') ? this.props.selections.group : false;
    const categorySelection = Object.prototype.hasOwnProperty.call(this.props.selections, 'category') ? this.props.selections.category : false;
    const lineupSelection = Object.prototype.hasOwnProperty.call(this.props.selections, 'lineup') ? this.props.selections.lineup : false;
    if (!groupSelection && !categorySelection && !lineupSelection) {
      this.setState(state => ({ error: true }));
      return;
    }
    else if (this.state.error) {
      this.setState(state => ({ error: false }));
    }

    this.props.updateResults(true);
  };

  resetFilters = () => {
    this.props.setFilterMode(FilterModes.FILTER_MODE, true);
    this.resetAll();
    this.props.updateResults(false);
  };

  switchToSearch = () => {
    this.props.setFilterMode(FilterModes.SEARCH_MODE, true);
  };

  onFocus = (e) => {
    this.props.setActiveMode(FilterModes.FILTER_MODE);
  };

  render() {
    let className = 'finder-mode product-finder-form';
    let disabled;
    if (this.props.activeMode === FilterModes.SEARCH_MODE) {
      className += ' inactive';
      disabled = true;
    }

    if (this.props.isFetching) {
      disabled = true;
    }
    //const { group, category, lineup, series } = buildFilters(this.props.finderFilters);
    const { group, category, lineup, series } = this.props.filtersOptions;
    const { error } = this.state;
    return (
      <form onFocus={this.onFocus} className={className}>
        <div className="form--inline" onFocus={this.onFocus}>
          {!this.props.redirectMode && (<h2 className="form__title block-title">{this.props.strings['STRING:TITLE']}</h2>)}
          <CustomSelectR
            ref={this.selectRefs.group}
            showError={error}
            isDisabled={this.props.isFetching || (group.length === 0)}
            isClearable={true}
            selectName="group"
            selectLabel={this.props.strings['STRING:GROUP_LABEL']}
            selectOptions={group}
            selectedValue={this.props.selections.group}
            onSelect={this.selectFilter}
            onAutoSelect={this.selectFilterAuto}
            withAutoSelect={false}
          />
          <CustomSelectR
            ref={this.selectRefs.category}
            showError={error}
            isDisabled={this.props.isFetching || (category.length === 0)}
            isClearable={true}
            selectedValue={this.props.selections.category}
            selectName="category"
            selectLabel={this.props.strings['STRING:CATEGORY_LABEL']}
            selectOptions={category}
            onSelect={this.selectFilter}
            onAutoSelect={this.selectFilterAuto}
            withAutoSelect={!this.props.isFetching} /* disable when fetching, to avoid selecting single values */
          />
          <CustomSelectR
            ref={this.selectRefs.lineup}
            showError={error}
            isDisabled={this.props.isFetching || (lineup.length === 0)}
            isClearable={true}
            selectedValue={this.props.selections.lineup}
            selectName="lineup"
            selectLabel={this.props.strings['STRING:LINE_UP_LABEL']}
            selectOptions={lineup}
            onSelect={this.selectFilter}
            onAutoSelect={this.selectFilterAuto}
            withAutoSelect={!this.props.isFetching} /* disable when fetching, to avoid selecting single values */
          />
          <CustomSelectR
            ref={this.selectRefs.series}
            showError={error}
            isDisabled={this.props.isFetching || (series.length === 0)}
            isClearable={true}
            selectedValue={this.props.selections.series}
            selectName="series"
            selectLabel={this.props.strings['STRING:SERIES_LABEL']}
            selectOptions={series}
            onSelect={this.selectFilter}
            onAutoSelect={this.selectFilterAuto}
            withAutoSelect={false}
            isMulti={true}
          />
          <div className="form__actions ">
            {((!!this.props.count && this.props.withResults) && <button disabled={disabled || this.props.isFetching} className="button submit" onClick={this.getResults} name="submit" type="button">{this.props.strings['STRING:SEE_RESULTS'].replace('!count', this.props.count)}</button>)}
            {((!this.props.count || !this.props.withResults) && <button disabled={disabled || this.props.isFetching} className="button submit" onClick={this.getResults} name="submit" type="button">{this.props.strings['STRING:FIND_YOUR_PRODUCT']}</button>)}
            <div className="form__actions__secondary">
              <button disabled={disabled} className="reset" onClick={this.resetFilters} name="reset-filters" type="button">{this.props.strings['STRING:RESET_FILTERS']}</button>
            </div>
          </div>
          {error && (<div className="error__message">{this.props.strings['STRING:ERROR_FINDER']}</div>)}
        </div>
        <div className="form--inline">
          
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state) => {
  let filtersOptions = selectFiltersOptions(state);
  let selections = selectParametersFilters(state);
  const count = selectResultsCount(state);
  const withResults = selectResultsResult(state)?.length > 0;
  const mode = selectParametersMode(state);
  const activeMode = selectParametersActiveMode(state);
  const isFetching = selectResultsIsFetching(state);
  
  return { filtersOptions, count, selections, mode, activeMode, isFetching, withResults }
};

export default connect(
  mapStateToProps,
  { selectFilter, updateResults, setFilterMode, setActiveMode, resetOnFilter, deletePath, requestResults },
  null,
  { forwardRef: true }
)(FinderModeComponent)

